export const THEME = {
	device: {
		sm: '@media only screen and (max-width: 320px)',
		md: '@media only screen and (max-width: 768px)',
		lg: '@media only screen and (min-width: 992px)',
		xl: '@media only screen and (min-width: 1200px)',
		xxl: '@media only screen and (min-width: 1600px)',
	},
};
